import CommonDefaults from './CommonDefaults';
import ConstituentField from './ConstituentField';
import TemporaryField from './TemporaryField';

const PersonDefaults = Object.freeze({
  ...CommonDefaults,
  [ConstituentField.FIRST_NAME]: '',
  [ConstituentField.LAST_NAME]: '',
  [ConstituentField.PREFIX]: '',
  [ConstituentField.PREFERRED_FIRST_NAME]: '',
  [ConstituentField.PRONOUNS]: '',
  [ConstituentField.DOB]: '',
  [ConstituentField.IS_DECEASED]: false,
  [TemporaryField.BIRTHDAY]: null,
});

export default PersonDefaults;
